import { gql } from '../../../apollo/__generated__';

export const UPDATE_USER_VALIDATED = gql(`
  mutation UpdateUserValidated($updateUserValidatedInput: UpdateUserValidatedInput!, $eventId: ID!) {
    updateUserValidated(updateUserValidatedInput: $updateUserValidatedInput) {
      id
      isValidated(eventId: $eventId)
    }
  }
`);
